var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryReactionsLoveFill = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 352.38 330.08",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.16,310.17c-5.97,0-11.94-1.59-17.26-4.78-6.69-4-8.11-4.93-8.58-5.23-56.07-36.34-95.76-74.67-117.95-113.91C7.87,142.95,10.41,108.73,16.85,87.64,29.27,47.01,67.58,19.14,109.91,19.92c3.06,.06,6.24,.28,9.47,.67,21.78,2.64,39.51,10.94,52.71,24.66,1.47,1.53,3.19,1.75,4.08,1.75s2.61-.23,4.08-1.75c13.2-13.72,30.94-22.01,52.71-24.66h0c43.43-5.28,85.89,20.91,100.93,62.27,7.69,21.16,11.84,55.68-12.05,100-21.69,40.24-61.75,79.54-119.08,116.81-1.39,.9-4.44,2.77-9.33,5.7-5.33,3.2-11.31,4.8-17.28,4.8Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryReactionsLoveFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Reactions_LoveFill.7bbea1b1.svg";
export { ForwardRef as ReactComponent };